import { ArrowUpToLineIcon } from 'lucide-react'

import { ActionRow } from '../../components/action-row/ActionRow'
import { ActionRowBaseProps } from '../../components/action-row/types'
import { ClaimPointsRewardsAction } from './types'

export interface ClaimPointsRewardsActionRowProps extends ActionRowBaseProps {
  action: ClaimPointsRewardsAction
}

export function ClaimPointsRewardsActionRow({ action, ...props }: ClaimPointsRewardsActionRowProps) {
  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={ArrowUpToLineIcon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={[action.token]} />
        Claim {action.token.symbol}
      </ActionRow.Title>

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>Claim</ActionRow.Trigger>
    </ActionRow>
  )
}
